import Rails from "@rails/ujs"
import "@hotwired/turbo-rails"
import "~/helpers/upsert_stream_action"
import * as ActiveStorage from "@rails/activestorage"
import '~/helpers/transition'
import '@captaincodeman/transition'
// import "flag-icon-css/css/flag-icon.min.css"

Rails.start()
ActiveStorage.start()

document.addEventListener("turbo:frame-missing", (event) => {
  event.preventDefault()
  event.detail.visit(event.detail.response)
})

import "~/controllers"
